import api from './api'

/**
 * Serviço de Parceiros
 */
export default {
  /**
   * Listar parceiros
   */
  list(params = {}) {
    return api.get('/api/partners', { params })
  },

  /**
   * Criar parceiro
   */
  create(partnerData) {
    return api.post('/api/partners', partnerData)
  },

  /**
   * Obter detalhes do parceiro
   */
  getById(id) {
    return api.get(`/api/partners/${id}`)
  },

  /**
   * Estatísticas do parceiro
   */
  getStats(id) {
    return api.get(`/api/partners/${id}/stats`)
  },

  /**
   * Alterar status do parceiro
   */
  updateStatus(id, status) {
    return api.put(`/api/partners/${id}/status`, { status })
  },
}
